import React from "react";

// Images
import slider1 from "./sliderPics/image_2021_02_18T14_39_10_071Z.png";
import slide2 from "./sliderPics/Typeform-Blog-BlackFriday-Cover-AskAwesomely.png";
import slide3 from "./sliderPics/web-designing-1.jpg";
import slide4 from "./sliderPics/image_2021_02_18T14_39_10_071Z.png";

import './animslider.css';

import back_apple_002 from "./img/New Project (2).png";
import bottle_apple_002 from "./img/BottleReacts.png";
import front_apple_002 from "./img/New Project (1).png";
import back_grapes_001 from "./img/back_grapes_001.png";
import bottle_grapes_001 from "./img/wordpresBottl.png";
import front_grapes_001 from "./img/wordpressPics.png";

import front_strawberry_003 from "./img/front_strawberry_003.png";
import bottle_strawberry_003 from "./img/CustonBottle.png";
import back_strawberry_003 from "./img/CustomPics.png";
// import SiteHome, { LinesAnimation, BallMove } from "./home.style";

// Components
import HeroSlider, {
  Slide,
  ButtonsNav,
  Nav,
  OverlayContainer,
} from "hero-slider";
import Wrapper from "./UI/Wrapper/Wrapper";
import Title from "./UI/Title/Title";
import Subtitle from "./UI/Subtitle/Subtitle";

const ZoomSlider = () => {
  const nextSlideHandler = React.useRef();
  const previousSlideHandler = React.useRef();

  return (
    <section class="page-wrapper">
      <div class="slider">
        <ul class="slider-list">
          <li class="slider-list__item  ">
            <span class="back__element">
              <img src={back_apple_002} />
            </span>
            <span class="main__element">
              <img src={bottle_apple_002} />
            </span>
            <span class="front__element">
              <img src={front_apple_002} />
            </span>
            <span class="title__element">
              {/* <span class="title">MernStack</span> */}
              <span class="title MernAnim">MernStack</span>
            </span>
            <span class="more__element">
              <span class="content">
                <span class="headline">TechSchema</span>
                <span class="excerpt">
                  TechSchema Now Build Most of its Company and all Clients
                  Website MernStack React NodeJs Development (Home Site, Admin
                  Panels).
                </span>
                <span class="link">
                  <div class="fill"></div>
                  <a href="#">Open catalog</a>
                </span>
              </span>
            </span>
          </li>

          <li class="slider-list__item">
            <span class="back__element">
              <img src={back_grapes_001.png} />
            </span>
            <span class="main__element">
              <img src={bottle_grapes_001} />
            </span>
            <span class="front__element">
              <img src={front_grapes_001} />
            </span>
            <span class="title__element">
              <span class="title MernAnim2">WordPress</span>
            </span>
            <span class="more__element">
              <span class="content">
                <span class="headline">TechSchema</span>
                <span class="excerpt">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo
                  ratione nisi perferendis? Nemo in accusamus cupiditate
                  officiis.
                </span>
                <span class="link">
                  <div class="fill fill-dark"></div>
                  <a href="#">Open catalog</a>
                </span>
              </span>
            </span>
          </li>

          <li class="slider-list__item">
            <span class="back__element">
              <img src={back_strawberry_003} />
            </span>
            <span class="main__element">
              <img src={bottle_strawberry_003} />
            </span>
            <span class="front__element">
              {/* <img src={front_strawberry_003} /> */}
            </span>
            <span class="title__element">
              <span class="title MernAnim3">CustomSite</span>
            </span>
            <span class="more__element">
              <span class="content">
                <span class="headline">TechSchema</span>
                <span class="excerpt">
                  Any Kind Of Frontend Websites Popups, Sliders like Slick
                  slider, carousal, killer carousal, Animations, WhatsApp popUp.
                </span>
                <span class="link">
                  <div class="fill"></div>
                  <a href="#">Open catalog</a>
                </span>
              </span>
            </span>
          </li>
        </ul>

        <div class="slider__nav-bar">
          <a class="nav-control"></a>
          <a class="nav-control"></a>
          <a class="nav-control"></a>
        </div>

        <div class="slider__controls">
          <a class="slider__arrow slider__arrow_prev"></a>
          <a class="slider__arrow slider__arrow_next"></a>
        </div>
      </div>
    </section>
  );
};

export default ZoomSlider;
